import React from 'react'
import { connect } from "react-redux";
import { SetDepositPayments_LBQR } from '$Deposits/store/actions/DepositPost'
import { LBQR_Submit } from '$Deposits/store/actions/DepositEvent'
import { GetParamsData } from '$Deposits/lib/LibCommonData'


class LBQR extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const { LivechatClick } = GetParamsData()
        const {
            TipsView,
            SetDepositPayments_LBQR,
            DepositNextStep,
            DepositSuccessPage,
            AvailableMethods,
            MoneyInput,
            SubmitBtn,
            NextStep,
            SuccessPage,
            BankSelect,
            // BanksBankAccounts = [],
            BankNone=false
        } = this.props
        return (
            <>
                {/* {
                    //没有银行卡
                    BankNone && BanksBankAccounts.length == 0 &&
                    <>
                        <BankNone LivechatClick={LivechatClick} methods={'LBQR'} />
                    </>
                } */}
                {
                    !DepositNextStep && !DepositSuccessPage &&
                    <>
                        <TipsView msg={`Vui lòng kiểm tra ứng dụng ngân hàng của bạn có được hỗ trợ chức năng quét mã QR trước khi làm lệnh. Hiện tại KHÔNG hỗ trợ chuyển khoản khác ngân hàng và chuyển tiền từ các ứng dụng quét mã QR khác.`} />
                        <AvailableMethods />
                        <MoneyInput />
                        <SubmitBtn
                            submitBtn={LBQR_Submit}
                            onPress={() => { SetDepositPayments_LBQR() }}
                            submitBtnItem={'Chuyển'}
                        />
                    </>
                }
                {
                    DepositNextStep &&
                    <NextStep />
                }
                {
                    DepositSuccessPage &&
                    <SuccessPage />
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositNextStep: state.DepositNextStep,
    DepositSuccessPage: state.DepositSuccessPage,
    // BanksBankAccounts: state.BanksBankAccounts,
});
const mapDispatchToProps = {
    SetDepositPayments_LBQR: (data = {}) => SetDepositPayments_LBQR(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(LBQR);


